import { EventContentArg } from '@fullcalendar/react';
import classNames from 'classnames';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import Tag from '../../../../components/Tag/Tag';
import { TagTypes } from '../../../../components/Tag/Tag.types';
import styles from './Calendar.module.css';

const CalendarEvent: FC<EventContentArg> = ({ event, isEnd, isStart }) => {
  const navigate = useNavigate();
  const { count, detailsLink, type } = event.extendedProps;
  const linkExists = detailsLink !== undefined || count !== undefined;
  if (event.display !== 'background') {
    return (
      <Tag
        data-testid="calendarEvent"
        title={event.title}
        label={event.title}
        fullWidth={type !== TagTypes.Holiday}
        className={classNames(styles.calendarEvent, styles.noRoundedCorners, {
          [styles.roundRight]: isEnd && type !== TagTypes.NationalDealOptIn,
          [styles.roundLeft]: isStart && type !== TagTypes.NationalDealLive,
          noMargin: type === TagTypes.NationalDealLive || type === TagTypes.NationalDealOptIn,
        })}
        type={type}
        link={
          linkExists
            ? {
                text: count !== undefined ? `(${count})` : 'Details',
                onClick: () => {
                  navigate(detailsLink);
                },
              }
            : undefined
        }
      />
    );
  }
  return null;
};

export default CalendarEvent;
